import React from 'react'
import { Button } from '@ally/metronome-ui'
import { muiChevronDown } from '@ally/metronome-icons'
import { asCurrency } from '@ally/aos-utils'
import { WealthTableData } from './TableColumns'

interface WealthDrawerButtonProps {
  data: WealthTableData
  isDrawerOpen?: boolean
  toggleDrawer: () => void
  drawerTriggerRef: React.RefObject<HTMLButtonElement>
}
const WealthDrawerButton: React.FC<WealthDrawerButtonProps> = props => {
  const {
    data: { totalValue },
    isDrawerOpen = false,
    toggleDrawer,
    drawerTriggerRef,
  } = props

  return (
    <Button
      data-testid="table-drawer-btn"
      variant="link"
      icon={{ map: muiChevronDown, position: 'right' }}
      text={asCurrency(totalValue)}
      onClick={(): void => {
        toggleDrawer()
      }}
      ref={drawerTriggerRef}
      aria-expanded={isDrawerOpen ? 'true' : 'false'}
      withAllyTM="wealthAccountDropdown"
    />
  )
}

export default WealthDrawerButton
